function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.766 7.937c2.027 4.618.66 9.682.66 9.682s-4.653-2.422-6.68-7.04-.66-9.683-.66-9.683 4.653 2.423 6.68 7.04z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.086.896l7.34 16.723"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.74 10.389c-1.81 3.252-5.399 4.708-5.399 4.708s-.652-3.816 1.16-7.069c1.81-3.252 5.398-4.708 5.398-4.708s.652 3.817-1.159 7.069z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.899 3.32l-6.557 11.777"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.342 26.043c-2.335-.952-3.607-3.246-3.607-3.246s2.514-.75 4.849.202 3.606 3.247 3.606 3.247-2.513.75-4.848-.203z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.191 26.245l-8.455-3.449"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.567 19.294c3.152 1.98 6.998 1.531 6.998 1.531s-1.265-3.66-4.416-5.64c-3.152-1.98-6.998-1.531-6.998-1.531s1.264 3.66 4.416 5.64z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.151 13.654l11.414 7.171"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.781 20.234c-3.572 1.046-7.15-.434-7.15-.434s2.214-3.177 5.786-4.223c3.572-1.046 7.15.434 7.15.434s-2.214 3.177-5.786 4.223z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.567 16.011l-12.936 3.788M28.391 17.346c.59 3.21.609 8.827.609 16.654M31.341 15.097l-2.515 6.597M24.565 20.825c2.832 1.25 3.555 2.817 4.435 4.348M31.522 19.955l-2.609 3.479M32.736 22.796c-.607-.194-1.412-.327-2.953-.232"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.966,
  cy: 33.5,
  rx: 12.5,
  ry: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.432 33.534L16.5 37.5c0 1.38 5.596 2.5 12.5 2.5s12.5-1.12 12.5-2.5l-.016-3.993"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 38.8l1.326 14.288c.098 1.063 4.328 1.933 9.666 1.933 5.339 0 9.666-.865 9.666-1.933L40 38.8"
})));

var SvgHouseplant = function SvgHouseplant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouseplant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/House plant.81ac4f0e.svg";
export { ForwardRef as ReactComponent };